import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { Area } from '../../../core/constants/area';
import { ToastrService } from 'ngx-toastr';
import { ConsoleLogger } from '../../../core/utilities/console-logger';
import { FileUploader } from 'ng2-file-upload';
import { HubSpotSandboxService } from '../../services/hubspot-sandbox.service';

@Component({
    selector: 'app-api-testing',
    templateUrl: './api-testing.component.html',
    styleUrls: ['./api-testing.component.scss'],
    encapsulation: ViewEncapsulation.None,
    providers: [HubSpotSandboxService]
})
export class APITestingComponent implements OnInit {

    isRunningIftaData = false;

    usDotNumber = '';

    documentUploader: any;
    fileDragged = false;
    URL = `${environment.dotNetApiUrl}/document`;

    constructor(
        private http: HttpClient,
        private toastrService: ToastrService,
        public sandbox: HubSpotSandboxService,
    ) { }

    ngOnInit() {
        this.setupFileUploader(); 
    }

    public onDragover() {
        this.fileDragged = true;
    }

    public onDragout() {
        this.fileDragged = false;
    }

    runSamsaraIftaData() {
        this.isRunningIftaData = true;
        this.http
            .post<any>(
                `${environment.dotNetApiUrl}/${Area.transportation}/Samsara/IFTA/Data`,
                {}
            )
            .subscribe(
                (x) => {
                    ConsoleLogger.logInfo(x);
                    this.toastrService.success(
                        "Samsara's IFTA data was successfully run."
                    );
                    this.isRunningIftaData = false;
                },
                (err) => {
                    console.error('Error:', err);
                    this.toastrService.error("Samsara's IFTA data failed to run.");
                    this.isRunningIftaData = false;
                }
            );
    }

    runSamsaraVehicleData() {
        this.isRunningIftaData = true;
        this.http
            .post<any>(
                `${environment.dotNetApiUrl}/${Area.transportation}/Samsara/Vehicle/List`,
                {}
            )
            .subscribe(
                (x) => {
                    ConsoleLogger.logInfo(x);
                    this.toastrService.success(
                        "Samsara's IFTA data was successfully run."
                    );
                    this.isRunningIftaData = false;
                },
                (err) => {
                    console.error('Error:', err);
                    this.toastrService.error("Samsara's IFTA data failed to run.");
                    this.isRunningIftaData = false;
                }
            );
    }

    setupFileUploader() {
        this.documentUploader = new FileUploader({
            url: this.URL,
            headers: [],
            disableMultipart: true,
            formatDataFunctionIsAsync: true,
            formatDataFunction: async (item) => {
                return new Promise((resolve, reject) => {
                    resolve({
                        name: item._file.name,
                        length: item._file.size,
                        contentType: item._file.type,
                        date: new Date(),
                    });
                });
            },
        });
    }

    syncHubSpotData() {
        this.isRunningIftaData = true;
        const portal = this.sandbox.portal();
        this.http
            .post<any>(
                `${environment.dotNetApiUrl}/${Area.core}/CoreCompany/HubSpot/Data`,
                {},
                { params: this.sandbox.withSandbox() }
            )
            .subscribe(
                (response) => {
                    ConsoleLogger.logInfo(response);
                    this.toastrService.success(`HubSpot invoice data synced (${portal}).`);
                    this.isRunningIftaData = false;
                },
                (err) => {
                    console.error('Error:', err);
                    this.toastrService.error(
                        'Testing HubSpot invoice data sync failed to run.'
                    );
                    this.isRunningIftaData = false;
                }
            );
    }

    testHubSpotCompanies(isGet: boolean) {
        this.isRunningIftaData = true;
        const portal = this.sandbox.portal();
        if (isGet == true) {
            this.http
                .get<any>(
                    `${environment.dotNetApiUrl}/${Area.core}/CoreCompany/HubSpot/Company/List`,
                    { params: this.sandbox.withSandbox() }
                )
                .subscribe(
                    (response) => {
                        ConsoleLogger.logInfo(response);
                        this.toastrService.success(`HubSpot companies logged to console (${portal}).`);
                        this.isRunningIftaData = false;
                    },
                    (err) => {
                        console.error('Error:', err);
                        this.toastrService.error('Testing HubSpot companies failed to run.');
                        this.isRunningIftaData = false;
                    }
                );
        } else {
            this.http
                .post<any>(
                    `${environment.dotNetApiUrl}/${Area.core}/CoreCompany/HubSpot/Company/List`,
                    {},
                    { params: this.sandbox.withSandbox() }
                )
                .subscribe(
                    (response) => {
                        ConsoleLogger.logInfo(response);
                        this.toastrService.success(`HubSpot companies synced (${portal}).`);
                        this.isRunningIftaData = false;
                    },
                    (err) => {
                        console.error('Error:', err);
                        this.toastrService.error(
                            'Testing HubSpot company sync failed to run.'
                        );
                        this.isRunningIftaData = false;
                    }
                );
        }
    }

    testHubSpotContacts() {
        this.isRunningIftaData = true;
        const portal = this.sandbox.portal();
        this.http
            .get<any>(
                `${environment.dotNetApiUrl}/${Area.core}/CoreCompany/HubSpot/Contact/List`,
                { params: this.sandbox.withSandbox() }
            )
            .subscribe(
                (response) => {
                    ConsoleLogger.logInfo(response);
                    this.toastrService.success(`HubSpot contacts logged to console (${portal}).`);
                    this.isRunningIftaData = false;
                },
                (err) => {
                    console.error('Error:', err);
                    this.toastrService.error('Testing HubSpot contacts failed to run.');
                    this.isRunningIftaData = false;
                }
            );
    }

    testSafer() {
        this.isRunningIftaData = true;
        this.http
            .get<any>(
                `${environment.dotNetApiUrl}/${Area.transportation}/Samsara/Test?usDotNumber=${this.usDotNumber}`
            )
            .subscribe(
                (response) => {
                    ConsoleLogger.logInfo(response);
                    this.toastrService.success('SAFER data logged to console.');
                    this.isRunningIftaData = false;
                },
                (err) => {
                    console.error('Error:', err);
                    this.toastrService.error('Testing SAFER failed to run.');
                    this.isRunningIftaData = false;
                }
            );
    }

    public uploadDocumentFile() {
        this.isRunningIftaData = true;
        if (this.documentUploader.queue[0]) {
            this.fileDragged = false;
        } else {
            this.isRunningIftaData = false;
            this.toastrService.warning('File upload not successful.');
            return;
        }
        const item = this.documentUploader.queue[0];
        const headers = new HttpHeaders();
        headers.set('Content-Type', null);
        headers.set('Accept', 'multipart/form-data');
        const params = new HttpParams();

        const file = item.file;
        const blob = new Blob([file.rawFile], { type: file.type });
        const formData = new FormData();
        formData.append(`${file.name}`, blob, `${file.name}`);
        this.http
            .post<any>(
                `${environment.dotNetApiUrl}/${Area.core}/FileImport/Textract/Parse`,
                formData,
                { params, headers }
            )
            .subscribe(
                (response) => {
                    ConsoleLogger.logInfo(response);
                    this.toastrService.success(
                        'File has been successfully uploaded and processed.'
                    );
                    this.documentUploader.clearQueue();
                    this.isRunningIftaData = false;
                },
                (err) => {
                    console.error('Error:', err);
                    this.toastrService.error('File upload failed to process.');
                    this.documentUploader.clearQueue();
                    this.isRunningIftaData = false;
                }
            );
    }
}


// WEBPACK FOOTER //
// ./src/app/developer/third-party/api-testing/api-testing.component.ts